import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { WxLaunchApp } from '../../../../../wxLaunchApp';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng/callapp';

class ShortFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    handleCallup = (
        isSendCount = true,
        isJumpQQlink = false,
        isCallApp = true
    ) => {
        const { content } = this.props;

        if(isCallApp) {
            if(content && content.callAppConfig) {
                content.callAppConfig.isCopySchemeUrl = isJumpQQlink;
                callApp(content.callAppConfig);
            } else {
                callApp({
                    docType: 'doc',
                    pid: content._id || content.base62Id || '',
                    kind: 'share01',
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                    isCopySchemeUrl: isJumpQQlink
                })
            }
        }
    }

    render() {
        const { 
            content,
            content: {
                isVideoShare,
                wxLaunchSwitch,
                wxLaunchType
            }
         } = this.props;
        const schemeLink = wxLaunchType === 'weapp' ? 
                                getWebAppLink({
                                    docType: 'short',
                                    pid: content._id || content.base62Id,
                                }) : getSchemeLink({
                                    docType: 'doc',
                                    pid: content._id || content.base62Id,
                                    kind: 'share01'
                                });

        return (
            <div className={styles.shortRelateBottom}  onClick={this.handleCallup}>
                <div className={styles.shortRelateItem}>
                    <span className={styles.shortRelateLike}>{parseInt(content.like) || ''}</span>
                </div>
                <div className={styles.shortRelateItem}>
                    <span className={styles.shortRelateComment}>{parseInt(content.commentsall) || ''}</span>
                </div>
                <div className={styles.shortRelateItem}>
                    <span className={styles.shortRelateTrun}>{parseInt(content.shareCount) || ''}</span>
                </div>
                {!isVideoShare &&
                    wxLaunchSwitch &&
                    <WxLaunchApp
                        launchType={wxLaunchType}
                        launchAppClick={this.handleCallup.bind(
                            this,
                            true,
                            false,
                            false,
                        )}
                        schemeLink={schemeLink}
                        launchAppFail={this.handleCallup.bind(
                            this,
                            false,
                            true,
                            true,
                        )}
                    />}
            </div>
        );
    }
}

export default ShortFooter;
